/*
  RheasRaw: "Goes well with" strip in the add-to-cart pop-up (Oct 2026).

  Empire's pop-up (the ATC banner, cloned from layout/theme.liquid into the
  header after each add) only showed the added item and a Checkout button, so
  anyone checking out from it never saw the basket page's "Frequently bought
  together". This adds up to 3 small cards with a one-tap Add inside the
  pop-up, using the same Search & Discovery pairings as the basket page
  (complementary first, then related). Nothing is shown if neither has stock.

  Adds go through /cart/add.js, so assets/rr-atc-source.js logs them in
  rr_atc_log as "popup_upsell". It also stamps the cart attribute
  rr_checkout_from ("popup" or "cart") on the two checkout forms, so orders
  show which Checkout button was used (the basket page also saves "cart" on
  the cart directly, because the fast checkout skips its form).
  Everything is best effort and never blocks the basket or checkout.

  Tidied Oct 2026: the cards show on the FIRST add of a visit only. Regulars
  quick-add 6-12 items, and a pop-up full of cards on every tap got in the
  way. Later adds get Empire's plain "Added" confirmation. Products shown here
  are remembered for the visit (sessionStorage rr_seen_recs) so the basket's
  "Add to your order" row doesn't offer them again.
*/
(function () {
  if (window.__rrAtcUpsell) return;
  window.__rrAtcUpsell = true;

  var cfgEl = document.querySelector('[data-rr-atc-upsell-config]');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }
  var MAX_ITEMS = cfg.maxItems || 3;
  var HEADING = cfg.heading || 'Goes well with';
  var moneyFormat = cfg.moneyFormat || '£{{amount}}';

  var SHOWN_KEY = 'rr_popup_recs_shown';
  var SEEN_KEY = 'rr_seen_recs';

  function store(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) { /* private mode etc. */ }
  }
  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function alreadyShown() {
    return read(SHOWN_KEY) === '1';
  }
  function rememberShown(candidates) {
    store(SHOWN_KEY, '1');
    var seen = [];
    try { seen = JSON.parse(read(SEEN_KEY) || '[]'); } catch (e) { seen = []; }
    if (!Array.isArray(seen)) seen = [];
    candidates.forEach(function (c) { if (seen.indexOf(c.product.id) === -1) seen.push(c.product.id); });
    store(SEEN_KEY, JSON.stringify(seen.slice(-30)));
  }

  var lastProductId = null;
  var lastAt = 0;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, moneyFormat);
    } catch (e) { /* fall through */ }
    return '£' + (cents / 100).toFixed(2);
  }

  function firstAvailable(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return null;
  }

  function recs(productId, intent) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=' + intent, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }

  function pick(products, exclude) {
    var out = [];
    products.forEach(function (p) {
      if (out.length >= MAX_ITEMS || exclude.indexOf(p.id) !== -1) return;
      var v = firstAvailable(p);
      if (v) out.push({ product: p, variant: v });
    });
    return out;
  }

  function findCandidates(productId, exclude) {
    return recs(productId, 'complementary').then(function (list) {
      var c = pick(list, exclude);
      if (c.length) return c;
      return recs(productId, 'related').then(function (list2) { return pick(list2, exclude); });
    });
  }

  function cardHtml(c) {
    var img = c.product.featured_image;
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    return '<li class="rr-atc-upsell__card" data-product-id="' + c.product.id + '">'
      + '<a class="rr-atc-upsell__img" href="' + c.product.url + '" tabindex="-1" aria-hidden="true">'
      + (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="64" height="64" loading="lazy">' : '')
      + '</a>'
      + '<a class="rr-atc-upsell__title" href="' + c.product.url + '">' + escapeHtml(c.product.title) + '</a>'
      + '<span class="rr-atc-upsell__price">' + money(c.variant.price) + '</span>'
      + '<button type="button" class="rr-atc-upsell__add" data-rr-atc-upsell-add="' + c.variant.id + '" aria-label="Add ' + escapeHtml(c.product.title) + ' to basket">Add</button>'
      + '</li>';
  }

  function render(banner, candidates) {
    if (!candidates.length || !banner.isConnected) return;
    var anchor = banner.querySelector('.atc-banner--product');
    if (!anchor || banner.querySelector('[data-rr-atc-upsell]')) return;
    var box = document.createElement('div');
    box.className = 'rr-atc-upsell';
    box.setAttribute('data-rr-atc-upsell', '');
    box.innerHTML = '<h3 class="rr-atc-upsell__heading">' + escapeHtml(HEADING) + '</h3>'
      + '<ul class="rr-atc-upsell__cards" role="list">' + candidates.map(cardHtml).join('') + '</ul>'
      + '<p class="rr-atc-upsell__message" role="status" hidden></p>';
    anchor.appendChild(box);
    rememberShown(candidates);
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('popup_upsell_viewed', { productIds: candidates.map(function (c) { return c.product.id; }).join(',') });
      }
    } catch (e) { /* analytics is best effort */ }
  }

  function updateBanner(banner, cart) {
    var sub = banner.querySelector('[data-atc-banner-cart-subtotal]');
    if (sub) sub.innerHTML = money(cart.total_price);
    var count = banner.querySelector('[data-atc-banner-cart-button] span');
    if (count) count.textContent = cart.item_count;
    try { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); } catch (e) { /* ignore */ }
  }

  function add(btn) {
    var banner = btn.closest('[data-atc-banner]');
    var card = btn.closest('.rr-atc-upsell__card');
    var msg = banner && banner.querySelector('.rr-atc-upsell__message');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (card) card.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: btn.getAttribute('data-rr-atc-upsell-add'), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        if (card) { card.classList.remove('is-adding'); card.classList.add('is-added'); }
        btn.textContent = 'Added ✓';
        if (banner) updateBanner(banner, cart);
      })
      .catch(function () {
        if (card) card.classList.remove('is-adding');
        btn.disabled = false;
        btn.textContent = 'Add';
        if (msg) { msg.textContent = 'Sorry, that could not be added. Please try again.'; msg.hidden = false; }
      });
  }

  function stampCheckoutForm(form, value) {
    if (!form || form.querySelector('input[name="attributes[rr_checkout_from]"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'attributes[rr_checkout_from]';
    input.value = value;
    form.appendChild(input);
  }

  function onBanner(banner) {
    if (banner.closest('[data-templates]') || banner.getAttribute('data-rr-seen')) return;
    banner.setAttribute('data-rr-seen', '1');
    stampCheckoutForm(banner.querySelector('form.atc-banner__form'), 'popup');
    if (cfg.enabled === false) return;
    if (alreadyShown()) return;           // suggestions on the first add of a visit only

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        var exclude = cart.items.map(function (i) { return i.product_id; });
        var productId = Date.now() - lastAt < 10000 ? lastProductId : null;
        if (!productId) productId = productFromTitle(banner, cart.items);
        if (!productId) productId = cart.items[0].product_id; // newest line is first
        return findCandidates(productId, exclude).then(function (c) { render(banner, c); });
      })
      .catch(function () { /* show nothing */ });
  }

  // Empire 14 no longer fires addToCartFlyout:complete, so match the title
  // it writes into the pop-up ("Purely Turkey 80-10-10 1kg", product title
  // then size) against the basket lines. The longest matching title wins.
  function productFromTitle(banner, items) {
    var el = banner.querySelector('[data-atc-banner-product-title]');
    var title = el ? el.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
    if (!title) return null;
    var best = null, bestLen = 0;
    for (var i = 0; i < items.length; i++) {
      var t = (items[i].product_title || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t && t.length > bestLen && (title === t || title.indexOf(t + ' ') === 0)) { best = items[i].product_id; bestLen = t.length; }
    }
    return best;
  }

  // Empire 13 fired this just before it put the pop-up into the header.
  document.addEventListener('addToCartFlyout:complete', function (e) {
    var d = e && e.detail && e.detail.responseData;
    if (d && d.product_id) { lastProductId = d.product_id; lastAt = Date.now(); }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-rr-atc-upsell-add]') : null;
    if (btn && !btn.disabled) add(btn);
  });

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('[data-atc-banner]')) onBanner(root);
    root.querySelectorAll('[data-atc-banner]').forEach(onBanner);
  }

  // Our own adds (calculator week buttons, Build a mix, basket quantity) fire
  // cart:refresh, but Empire 14's basket icon only listens for cartcount:update
  // and draws the number from an attribute. Pass the new count on so the icon
  // updates (added 25 Oct 2026).
  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart })); })
      .catch(function () { /* the icon is cosmetic */ });
  });

  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Basket page: mark its checkout form so orders show "cart".
  // The fast checkout (sections/rr-fast-checkout.liquid) usually skips the form
  // and goes straight to /checkout, so that hidden input never gets sent. So the
  // basket page also saves rr_checkout_from=cart on the cart itself as it loads
  // (fixed 8 Oct 2026). A later Checkout from the pop-up still overwrites it
  // with "popup", because that form posts its own hidden input.
  function stampCartPage() {
    if (!document.body.classList.contains('template-cart')) return;
    var btn = document.querySelector('form[action*="/cart"] button[name="checkout"]:not(.atc-button--checkout)');
    if (btn && !btn.closest('[data-atc-banner]')) stampCheckoutForm(btn.form || btn.closest('form'), 'cart');
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;
        if (cart.attributes && cart.attributes.rr_checkout_from === 'cart') return;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { rr_checkout_from: 'cart' } })
        });
      })
      .catch(function () { /* never let tagging affect the basket */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stampCartPage); else stampCartPage();
}());
